import { Component,Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { UserService } from 'src/services/user.service';

@Component({
  selector: 'app-userfcmkey',
  templateUrl: './userfcmkey.component.html',
  styleUrls: ['./userfcmkey.component.css']
})
export class UserfcmkeyComponent implements OnInit {

  userKeys: any[] = [];
  // columns: any[] = [
	// 	{ name: "fcmKey", displayName: "Fcm key" },
	// 	{ name: "platform", displayName: "Platform" }
	// ];
  // totalCount: number = 5;
  
  constructor(
    private dialogRef: MatDialogRef<UserfcmkeyComponent>,
    @Inject(MAT_DIALOG_DATA)public data:any,
    private userService: UserService,  
  ) { }
  
  ngOnInit() {
    // console.log('rec',this.data);
    if (this.data) {
      this.userService.getFcmkeyUserDetails(this.data.id).subscribe((res: any) => {
        this.userKeys= res.data;
        // console.log('user',this.userKeys);
      });
    }
  }
}
